export enum SvgGraphics {
  A1 = "A1",
  A2 = "A2",
  A3 = "A3",
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
  A7 = "A7",
  A8 = "A8",
  A9 = "A9",
  A10 = "A10",
  A11 = "A11",
  A12 = "A12",
  A13 = "A13",
  A14 = "A14",
  A15 = "A15",
  A16 = "A16",
  A17 = "A17",
  A18 = "A18",
  A19 = "A19",
  A20 = "A20",
  A21 = "A21",
  A22 = "A22",
  A23 = "A23",
  A24 = "A24",
  A25 = "A25",
  A26 = "A26",
  A27 = "A27",
  A28 = "A28",
  A29 = "A29",
  A30 = "A30",
  A31 = "A31",
  A32 = "A32",
  A33 = "A33",
  A34 = "A34",
  A35 = "A35",
  A36 = "A36",
  A37 = "A37",
  A38 = "A38",
  D1 = "D1",
  D2 = "D2",
  A41 = "A41",
  A42 = "A42",
  A43 = "A43",
  A44 = "A44",
  A45 = "A45",
  A46 = "A46",
  A47 = "A47",
  A48 = "A48",
  A49 = "A49",
  A50 = "A50",
  A51 = "A51",
  A52 = "A52",
  A53 = "A53",
  A54 = "A54",
  A55 = "A55",
  A56 = "A56",
  A57 = "A57",
  A58 = "A58",
  A59 = "A59",
  A60 = "A60",
  A61 = "A61",
  A62 = "A62",
  A63 = "A63",
  A64 = "A64",
  A65 = "A65",
  A66 = "A66",
  A67 = "A67",
}
